// extracted by mini-css-extract-plugin
export var container = "_cv-0";
export var infoIcon = "_cv-2";
export var titleRowCol = "_cv-1";